// extracted by mini-css-extract-plugin
export var post = "Post-module--post--1MpL7";